module.exports = __webpack_public_path__ + "img/btn-intro-movie@2x.5da07195.jpg";